// The public URL an external system posts to, on the same API host this app talks to
export const buildWebhookUrl = (webhookSlug: string, resource: string): string =>
  `${import.meta.env.VITE_API_URL.replace(/\/+$/, '')}/webhooks/${webhookSlug}/${resource}`;

// What a bcrypt hash looks like, e.g. the value of a SCI_<COMPANY>_TOKEN env var
export const isBcryptHash = (value: string): boolean => /^\$2[aby]\$\d{2}\$[./A-Za-z0-9]{53}$/.test(value);
